import { IGetInfrastructureV4Response } from 'shared/common/repositories/infrastructure-caching/entities/get_infrastructure/GetInfrastructureV4Response';
import {
  fetchGetInfrastructure,
  TGetInfrastructureRequest,
} from 'shared/common/repositories/infrastructure-caching/v4/get-infrastructure';
import { restApiFunctionWrapper } from 'shared/common/utils/restApiWrapper/restApiWrapper';

export const fetchInfrastructure = restApiFunctionWrapper<TGetInfrastructureRequest, IGetInfrastructureV4Response>(
  fetchGetInfrastructure,
);
